module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0098.jpg?v=13c17cab";